/**
 * @generated SignedSource<<de76c2de3857e5b5d139171ec84c830c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromotionActionEnum = "promotion_activate" | "promotion_create" | "promotion_deactivate" | "promotion_delete" | "promotion_update" | "%future added value";
export type PromotionId_promotionQuery$variables = {
  id: string;
};
export type PromotionId_promotionQuery$data = {
  readonly promotion: {
    readonly actions: ReadonlyArray<PromotionActionEnum>;
    readonly id: string;
    readonly page: {
      readonly __typename: "PromotionPage";
      readonly bannerBackgroundColor: string;
      readonly bannerImage: {
        readonly objectUrl: string;
      } | null;
      readonly bannerSubText: string;
      readonly bannerSubTextColor: string;
      readonly bannerTitle: string;
      readonly bannerTitleColor: string;
      readonly detailBackgroundColor: string;
      readonly detailButtonText: string;
      readonly detailImages: ReadonlyArray<{
        readonly image: {
          readonly objectUrl: string;
        };
      }> | null;
      readonly miniBannerSubText: string;
      readonly miniBannerTitle: string;
    } | null;
    readonly problemEvent: {
      readonly __typename: "PromotionProblemEvent";
    } | null;
    readonly productEvent: {
      readonly discounts: ReadonlyArray<{
        readonly amount: number;
        readonly id: string;
        readonly mobileImage: {
          readonly id: string;
        } | null;
        readonly product: {
          readonly title: string;
        };
        readonly webImage: {
          readonly id: string;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"ProductDiscountUpdateDialog_productDiscount">;
      }>;
    } | null;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"PromotionActionsMutationButtonStack_promotion" | "PromotionDescriptionList_promotion" | "PromotionPageUpsertDialog_promotion" | "PromotionProblemEventDescriptionList_promotion" | "PromotionProblemEventUpsertDialog_promotion" | "PromotionProductEventDescriptionList_promotion" | "PromotionProductEventUpsertDialog_promotion">;
  };
};
export type PromotionId_promotionQuery = {
  response: PromotionId_promotionQuery$data;
  variables: PromotionId_promotionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  (v2/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bannerBackgroundColor",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectUrl",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bannerSubText",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bannerSubTextColor",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bannerTitle",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bannerTitleColor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "miniBannerSubText",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "miniBannerTitle",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailBackgroundColor",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailButtonText",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v21 = [
  (v19/*: any*/),
  (v9/*: any*/),
  (v20/*: any*/),
  (v2/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationDays",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationHours",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offsetHours",
  "storageKey": null
},
v25 = [
  (v2/*: any*/),
  (v19/*: any*/),
  (v9/*: any*/),
  (v20/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionId_promotionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Promotion",
        "kind": "LinkedField",
        "name": "promotion",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PromotionActionsMutationButtonStack_promotion"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PromotionDescriptionList_promotion"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PromotionProblemEventDescriptionList_promotion"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PromotionProblemEventUpsertDialog_promotion"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PromotionProblemEvent",
            "kind": "LinkedField",
            "name": "problemEvent",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PromotionProductEventDescriptionList_promotion"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PromotionProductEventUpsertDialog_promotion"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PromotionProductEvent",
            "kind": "LinkedField",
            "name": "productEvent",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductDiscount",
                "kind": "LinkedField",
                "name": "discounts",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "webImage",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "mobileImage",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ProductDiscountUpdateDialog_productDiscount"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PromotionPageUpsertDialog_promotion"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PromotionPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "bannerImage",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DetailImageDeeplink",
                "kind": "LinkedField",
                "name": "detailImages",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionId_promotionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Promotion",
        "kind": "LinkedField",
        "name": "promotion",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priority",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRepeat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "repeatType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "repeatValue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "query",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PromotionPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "bannerImage",
                "plural": false,
                "selections": (v21/*: any*/),
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "detailButtonLink",
                "storageKey": null
              },
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DetailImageDeeplink",
                "kind": "LinkedField",
                "name": "detailImages",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deeplink",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "picture",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isDeleted",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PromotionProblemEvent",
            "kind": "LinkedField",
            "name": "problemEvent",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              (v23/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              (v24/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1
              }
            ],
            "kind": "ScalarField",
            "name": "nextOccurrences",
            "storageKey": "nextOccurrences(limit:1)"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PromotionProductEvent",
            "kind": "LinkedField",
            "name": "productEvent",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductDiscount",
                "kind": "LinkedField",
                "name": "discounts",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Product",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "webImage",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "mobileImage",
                    "plural": false,
                    "selections": (v25/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "backgroundColor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "012423ebebb00d9d28e6a5116aa6199b",
    "id": null,
    "metadata": {},
    "name": "PromotionId_promotionQuery",
    "operationKind": "query",
    "text": "query PromotionId_promotionQuery(\n  $id: ID!\n) {\n  promotion(id: $id) {\n    id\n    title\n    actions\n    ...PromotionActionsMutationButtonStack_promotion\n    ...PromotionDescriptionList_promotion\n    ...PromotionProblemEventDescriptionList_promotion\n    ...PromotionProblemEventUpsertDialog_promotion\n    problemEvent {\n      __typename\n    }\n    ...PromotionProductEventDescriptionList_promotion\n    ...PromotionProductEventUpsertDialog_promotion\n    productEvent {\n      discounts {\n        id\n        webImage {\n          id\n        }\n        mobileImage {\n          id\n        }\n        amount\n        product {\n          title\n          id\n        }\n        ...ProductDiscountUpdateDialog_productDiscount\n      }\n    }\n    ...PromotionPageUpsertDialog_promotion\n    page {\n      __typename\n      bannerBackgroundColor\n      bannerImage {\n        objectUrl\n        id\n      }\n      bannerSubText\n      bannerSubTextColor\n      bannerTitle\n      bannerTitleColor\n      miniBannerSubText\n      miniBannerTitle\n      detailBackgroundColor\n      detailImages {\n        image {\n          objectUrl\n          id\n        }\n      }\n      detailButtonText\n    }\n  }\n}\n\nfragment ProductDiscountUpdateDialog_productDiscount on ProductDiscount {\n  id\n  product {\n    id\n    title\n  }\n  webImage {\n    key\n    objectUrl\n    size\n    id\n  }\n  mobileImage {\n    key\n    objectUrl\n    size\n    id\n  }\n  backgroundColor\n}\n\nfragment PromotionActionsMutationButtonStack_promotion on Promotion {\n  id\n  actions\n  ...PromotionUpdateDialog_promotion\n}\n\nfragment PromotionDescriptionList_promotion on Promotion {\n  id\n  title\n  priority\n  page {\n    __typename\n  }\n  startAt\n  endAt\n  ...PromotionRepeatText_promotion\n  query\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  created\n  ...PromotionStatusLabel_promotion\n}\n\nfragment PromotionPageUpsertDialog_promotion on Promotion {\n  id\n  page {\n    bannerBackgroundColor\n    bannerImage {\n      key\n      objectUrl\n      size\n      id\n    }\n    bannerSubText\n    bannerSubTextColor\n    bannerTitle\n    bannerTitleColor\n    detailBackgroundColor\n    detailButtonLink\n    detailButtonText\n    detailImages {\n      image {\n        key\n        objectUrl\n        size\n        id\n      }\n      deeplink\n    }\n    miniBannerSubText\n    miniBannerTitle\n  }\n}\n\nfragment PromotionProblemEventDescriptionList_promotion on Promotion {\n  problemEvent {\n    durationDays\n    durationHours\n    count\n    offsetHours\n  }\n}\n\nfragment PromotionProblemEventUpsertDialog_promotion on Promotion {\n  id\n  nextOccurrences(limit: 1)\n  startAt\n  problemEvent {\n    durationHours\n    durationDays\n    count\n    offsetHours\n  }\n}\n\nfragment PromotionProductEventDescriptionList_promotion on Promotion {\n  productEvent {\n    title\n    durationDays\n    durationHours\n    offsetHours\n  }\n}\n\nfragment PromotionProductEventUpsertDialog_promotion on Promotion {\n  id\n  nextOccurrences(limit: 1)\n  startAt\n  productEvent {\n    title\n    durationHours\n    durationDays\n    offsetHours\n    discounts {\n      product {\n        id\n      }\n      amount\n      id\n    }\n  }\n}\n\nfragment PromotionRepeatText_promotion on Promotion {\n  isRepeat\n  repeatValue\n  repeatType\n}\n\nfragment PromotionStatusLabel_promotion on Promotion {\n  status\n}\n\nfragment PromotionUpdateDialog_promotion on Promotion {\n  id\n  title\n  priority\n  startAt\n  endAt\n  isRepeat\n  repeatType\n  repeatValue\n  query\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "4782c6e89ecae737047cd9dbffa983b4";

export default node;
